import * as React from 'react';

import { OverviewViewModel } from 'models';

import { UitkIcon, UitkIconSize } from 'uitk-react-icons';

interface MapAddressLineProps {
  overview?: OverviewViewModel;
  className?: string;
}

export const MapAddressLine = ({ overview, className }: MapAddressLineProps) => {
  if (!overview) {
    return null;
  }

  const { addressLine, streetAddress, city, state, countryCode } = overview;

  return (
    <div
      data-stid="content-hotel-address"
      itemProp="address"
      itemScope={true}
      itemType="http://schema.org/PostalAddress"
      className={className}
    >
      <UitkIcon name="place" size={UitkIconSize.EXTRA_SMALL} />
      <span className="uitk-type-300 uitk-type-center">{addressLine}</span>
      <meta itemProp="streetAddress" content={streetAddress} />
      <meta itemProp="addressLocality" content={city} />
      <meta itemProp="addressRegion" content={state} />
      <meta itemProp="addressCountry" content={countryCode} />
    </div>
  );
};
